import React, { memo, type ReactElement } from 'react';
import { Box, TabContent } from '@saviynt/design-system';
import cx from 'classnames';

import { SodSidePanelUser } from '../../../../shared/components';
import { ENTITLEMENT_DEATILS_TABS } from '../../../../shared/constants';
import { useInvertedLocalize } from '../../../../shared/hooks';

import EntitlementInherentRisks from './InherentRisksTab/InherentRisks';
import EntitlementViolationsTab from './ViolationsTab/EntitlementViolationsTab';
import EntitlementSummary from './EntitlementSummary';

import './EntitlementDetails.css';

interface EntitlementDetailsProps {
  activeTab: string;
  className?: string;
}

/**
 * EntitlementDetails
 */
function EntitlementDetails({
  activeTab,
  className,
}: EntitlementDetailsProps): ReactElement {
  const l = useInvertedLocalize();
  /* To be discussed with the UX team */
  // const {
  //   controls: { tabFilter },
  // } = useTypedSelector((state) => state.aag.violationsTab);

  const wrapperClasses = cx('Sod-EntitlementDetails', className);

  const tabConfigs: {
    key: keyof typeof ENTITLEMENT_DEATILS_TABS;
    label: string;
    content?: ReactElement;
  }[] = [
    {
      key: 'TAB_SUMMARY',
      label: l('Summary'),
      content: <EntitlementSummary activeTab={activeTab} />,
    },
    {
      key: 'TAB_RISKS',
      label: l('Inherent Risks'),
      content: <EntitlementInherentRisks />,
    },
    {
      key: 'TAB_USERS',
      label: l('Users'),
      content: <SodSidePanelUser usernameQuery='' />,
    },
    {
      key: 'TAB_VIOLATIONS',
      label: l('Violations'),
      content: <EntitlementViolationsTab />,
    },
  ];

  /* To be discussed with the UX team */
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   const desiredValues = new Set([
  //     'openCount',
  //     'mitigatedCount',
  //     'inReviewCount',
  //   ]);

  //   const filtered = tabFilter.filter((item: any) =>
  //     desiredValues.has(item.value)
  //   );

  //   dispatch(violationsTabActions.setTabFilters(filtered));
  // }, [activeTab]);

  return (
    <Box tag='div' className={wrapperClasses}>
      {tabConfigs.map(({ key, label, content }) => (
        <TabContent
          key={key}
          className={cx(`Sod-EntitlementDetails-tabContent-${key}`)}
          value={activeTab}
          tabValue={ENTITLEMENT_DEATILS_TABS[key]}>
          {content ?? (
            <>
              This is the {label} tab ({activeTab})
            </>
          )}
        </TabContent>
      ))}
    </Box>
  );
}

EntitlementDetails.defaultProps = {
  className: null,
};

export default memo(EntitlementDetails);
